import { getAdjustedDirection, INITIAL_FRAME_OFFSET } from '../../utils';
export function getNames(_) {
  return ['motion-fadeIn', 'motion-flipIn'];
}
const DIRECTIONS = ['top', 'right', 'bottom', 'left'];
const POWER_TO_ROTATE_MAP = {
  soft: 45,
  medium: 90,
  hard: 270
};
function getRotateFrom(direction, rotate) {
  return {
    x: ROTATE_MAP[direction].x * rotate,
    y: ROTATE_MAP[direction].y * rotate
  };
}
const ROTATE_MAP = {
  top: {
    x: 1,
    y: 0
  },
  right: {
    x: 0,
    y: 1
  },
  bottom: {
    x: -1,
    y: 0
  },
  left: {
    x: 0,
    y: -1
  }
};
export function web(options, dom) {
  prepare(options, dom);
  return style(options);
}
export function style(options) {
  const {
    direction = 'top',
    power,
    initialRotate = 90
  } = options.namedEffect;
  const [fadeIn, flipIn] = getNames(options);
  const rotate = power && POWER_TO_ROTATE_MAP[power] || initialRotate;
  const easing = options.easing || 'backOut';
  const from = getRotateFrom(direction, rotate);
  const custom = {
    '--motion-rotate-x': `${from.x}deg`,
    '--motion-rotate-y': `${from.y}deg`
  };
  return [{
    ...options,
    easing: 'quadOut',
    name: fadeIn,
    custom: {},
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: 'var(--comp-opacity, 1)'
    }]
  }, {
    ...options,
    easing,
    name: flipIn,
    custom,
    keyframes: [{
      offset: INITIAL_FRAME_OFFSET,
      transform: `perspective(800px) rotate(var(--comp-rotate-z, 0deg)) rotateX(var(--motion-rotate-x , ${custom['--motion-rotate-x']})) rotateY(var(--motion-rotate-y , ${custom['--motion-rotate-y']}))`
    }, {
      transform: `perspective(800px) rotate(var(--comp-rotate-z, 0deg)) rotateX(0deg) rotateY(0deg)`
    }]
  }];
}
export function prepare(options, dom) {
  const {
    direction = 'top',
    power,
    initialRotate = 90
  } = options.namedEffect;
  const rotate = power && POWER_TO_ROTATE_MAP[power] || initialRotate;
  if (dom) {
    let adjustedDirection = direction;
    dom.measure(target => {
      if (!target) {
        return;
      }
      const rotation = getComputedStyle(target).getPropertyValue('--comp-rotate-z') || '0deg';
      adjustedDirection = getAdjustedDirection(DIRECTIONS, direction, parseInt(rotation, 10));
    });
    dom.mutate(target => {
      const from = getRotateFrom(adjustedDirection, rotate);
      target == null || target.style.setProperty('--motion-rotate-x', `${from.x}deg`);
      target == null || target.style.setProperty('--motion-rotate-y', `${from.y}deg`);
    });
  }
}
//# sourceMappingURL=FlipIn.js.map